import * as Yup from 'yup';

export interface IEducationDetails {
  education_id: string;
  degree: string;
  institution_name: string;
  percentage: string;
  passed_year: string;
  level: string;
}

export const educationDetailsInitialValue: IEducationDetails = {
  education_id: '',
  degree: '',
  institution_name: '',
  percentage: '',
  passed_year: '',
  level: ''
};

export const EducationDetailsSchemaValidation = Yup.object().shape({
  institution_name: Yup.string().required('Education Id is required'),
  degree: Yup.string().required('Degree is required'),
  percentage: Yup.string().required('Percentage is required'),
  passed_year: Yup.string().nullable(),
  level: Yup.string().required('Level is required')
});
